import React from 'react';
import {withRouter} from 'react-router-dom';
import {routePainted} from './performance';

function RouteTiming({location}) {
  React.useEffect(()=>{
    let second;
    const first=requestAnimationFrame(()=>{second=requestAnimationFrame(routePainted);});
    return ()=>{cancelAnimationFrame(first);if(second)cancelAnimationFrame(second);};
  },[location.pathname]);
  return null;
}
export default withRouter(RouteTiming);
